import { useUnsignedConsents } from '@app/main/api';
import { useUserContextSelector } from '@app/main/utils';
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function ConsentSignatureEnforcer({ userId }: { userId: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { consents, isLoading, isFetching } = useUnsignedConsents({ assigneeId: userId, isMandatory: true });
  const mandatoryConsentId = consents?.[0]?.id;
  const mandatoryConsentPath = mandatoryConsentId ? `/consent/${mandatoryConsentId}` : undefined;
  const isOnConsentPage = location.pathname === mandatoryConsentPath;

  useEffect(() => {
    if (isLoading || isFetching || !mandatoryConsentPath || isOnConsentPage) {
      return;
    }
    navigate(mandatoryConsentPath, { replace: true });
  }, [isLoading, isFetching, mandatoryConsentPath, isOnConsentPage, navigate]);

  return null;
}

export function ConsentSignatureEnforcerWidget() {
  const [userId, isPatient] = useUserContextSelector((x) => [x.id, x.hasRole('PATIENT')]);

  if (!isPatient || !userId) return null;

  return <ConsentSignatureEnforcer userId={userId} />;
}
